import { render } from "./EmailList.vue?vue&type=template&id=068c53cd"
import script from "./EmailList.vue?vue&type=script&lang=js"
export * from "./EmailList.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./EmailList.vue?vue&type=style&index=0&id=068c53cd&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__